import { BaseModelService } from "./base-model.service"
import { Injectable } from "@angular/core"
import { SmsTemplateSerializer } from "serializers"
import { Observable } from "rxjs"
import { SmsTemplate } from "./sms-template.model"
import { SmsKind } from "./sms-kind.model"

@Injectable()
export class SmsTemplateService extends BaseModelService<SmsTemplate> {
  constructor() {
    super()

    this.configure({
      basePath:  'sms_templates',
      key:       'sms_template',
      pluralKey: 'sms_templates',
      serializer: SmsTemplateSerializer
    })
    
  }

  kindList(): Observable<SmsKind[]> {
    let url = this.buildUrl('kind_list')
    return this.get(url).map(data => {
      return data['kindList'] as SmsKind[]
    })
  }

  fittedList(kind: string): Observable<SmsTemplate[]> {
    let url = this.buildUrl()
    return this.get(url, { kind: kind }).map(data => {
      return data['smsTemplates'] as SmsTemplate[]
    })
  }

  saveTranslations(id: number, translations: any): Observable<SmsTemplate> {
    let url = this.buildUrl(id)
    return this.patch(url, { translations: translations }).map(data => {
      return data['smsTemplate'] as SmsTemplate
    })
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/sms-template.service.ts